import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IRawFileRepository } from "@domain/repositories/IRawFileRepository";
import type { RawFileUsage } from "@domain/schemas/BI";

/**
 * Deletion of raw files and folders, plus the usage lookup that must precede a file deletion.
 *
 * Deleting is irreversible and the backend keeps no referential integrity between raw files and the jobs that
 * consumed them. Callers run `getUsageAsync` for both files and folders, using the same project and storage
 * root for the lookup and deletion.
 */
@injectable()
class DeleteRawFileService {
  @inject(TYPES.IRawFileRepository)
  private _rawFileRepository!: IRawFileRepository;

  async getUsageAsync(projectId: string, fileName: string, folder?: string, isFolder?: boolean, rootPath?: string | null): Promise<RawFileUsage> {
    return this._rawFileRepository.getRawFileUsage(projectId, fileName, folder, isFolder, rootPath);
  }

  async executeAsync(projectId: string, fileName: string, folder?: string, isFolder?: boolean, rootPath?: string | null): Promise<boolean> {
    return this._rawFileRepository.deleteRawFile(projectId, fileName, folder, isFolder, rootPath);
  }
}

export { DeleteRawFileService };
